import { FunctionComponent, PropsWithChildren } from 'react';
import { useSelector } from '@cbridge-utils/react-redux';
import { FormProvider } from '@cbridge-tools/form';
import { detailsSidebarModeSelector, SidebarOpenMode } from '@cbridge-packages/details-sidebar';
import { useStreamFormSchema } from '@cbridge-modules/stream-form';
import { streamFormProviderPropsSelector } from './StreamFormProvider.selector';

export const StreamFormProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const schema = useStreamFormSchema();

  const { disabled, values, defaultValues } = useSelector(streamFormProviderPropsSelector);
  const mode = useSelector(detailsSidebarModeSelector);

  return (
    <FormProvider
      schema={schema}
      values={values}
      disabled={disabled}
      defaultValues={defaultValues}
      enableFieldRevert={mode !== SidebarOpenMode.Create}
    >
      {children}
    </FormProvider>
  );
};
